<template>
  <section
    id="overview"
    class="pdp-overview-container"
  >
    <h3 class="pdp-section-header font-weight-bold">
      Overview
    </h3>
    <div ref="overviewTop">
      <ProductsOverviewMedia
        :media="[deal.overview_media[0]]"
        :include-show-more="supportsShowMore && !isOpen"
        @show-more="toggleShow"
      />
      <CollapseTransition
        dimension="height"
        name="slide"
        :duration="400"
      >
        <div v-show="isOpen">
          <ProductsOverviewMedia :media="deal.overview_media.slice(1)" />
        </div>
      </CollapseTransition>
      <div
        v-if="supportsShowMore && isOpen"
        class="button-container"
      >
        <button
          @click="toggleShow"
          @keypress="toggleShow"
        >
          Hide details
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import get from 'lodash/get';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

import ProductsOverviewMedia from './ProductsOverviewMedia.vue';

export default {
  components: {
    CollapseTransition,
    ProductsOverviewMedia,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    supportsShowMore() {
      return this.deal.overview_media.length > 1;
    },
  },
  methods: {
    toggleShow() {
      const top = get(this, ['$refs', 'overviewTop', 'offsetTop']);

      if (this.isOpen && top) {
        window.scrollTo({
          top,
          behavior: 'smooth',
        });
        setTimeout(() => { this.isOpen = false; }, 500);
      } else {
        this.isOpen = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  /* TODO -- Remove once this is a global style */
  @import '~/styles/dorado/main';

  .button-container {
    button {
      border: 2px solid $deep-ocean;
      border-radius: 20px;
      background-color: #fff;
      color: $deep-ocean;
      font-family: $headings-font-family;
      font-weight: $headings-font-weight;
      font-size: 16px;
      transition: background-color 150ms;
      padding: 4px 20px;

      &:focus {
        outline: none;
      }

      &:hover {
        background-color: rgba(14, 110, 244, 0.1);
      }
    }
  }

  .title:not([class*='display-']) {
    font-size: 28px;
    font-weight: 600 !important;
    line-height: 42px;
    margin-bottom: 24px;
  }

  @include media-breakpoint-up(lg) {
    .title:not([class*='display-']) {
      font-weight: 700 !important;
    }
  }
</style>
